export enum LEAD_STATUS{
  OPEN = 'Open',
  CONVERTED = 'Converted',
  CANCEL = 'Cancel',
  OPPORTUNITY = 'opportunity'
}